{
  "version": 1,
  "meta": {
    "id": "first-derivative",
    "name": "First Derivative",
    "description": "A gentle introduction to the world of TriggernometryDash",
    "author": "TriggernometryDash",
    "difficulty": "easy",
    "version": 1,
    "parTime": 45000,
    "optimalInputs": 28,
    "tags": [
      "tutorial",
      "real"
    ]
  },
  "settings": {
    "initialMode": "real",
    "initialSpeed": 1.0,
    "initialPlayerMode": "triangle",
    "baseColor": "#00ffff",
    "accentColor": "#ffffff",
    "backgroundColor": "#0a0a0a",
    "gridIntensity": 0.6,
    "music": {
      "bpm": 110,
      "key": "Am",
      "style": "synthwave",
      "song": "neon-drive",
      "layers": [
        "bass",
        "drums"
      ]
    },
    "fog": {
      "near": 50,
      "far": 200,
      "color": "#0a0a1a"
    }
  },
  "segments": [
    {
      "id": "seg-01-intro",
      "mode": "real",
      "length": 600,
      "speed": 1.0,
      "terrain": {
        "type": "flat",
        "floor": {
          "function": "constant",
          "offset": 80
        },
        "ceiling": null
      },
      "obstacles": [],
      "decorations": []
    },
    {
      "id": "seg-02-single-spikes",
      "mode": "real",
      "length": 1200,
      "speed": 1.0,
      "terrain": {
        "type": "flat",
        "floor": {
          "function": "constant",
          "offset": 80
        },
        "ceiling": null
      },
      "obstacles": [
        {
          "type": "spike",
          "position": {
            "along": 200,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 500,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 750,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 1050,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        }
      ],
      "decorations": []
    },
    {
      "id": "seg-03-double-spikes",
      "mode": "real",
      "length": 1200,
      "speed": 1.0,
      "terrain": {
        "type": "flat",
        "floor": {
          "function": "constant",
          "offset": 80
        },
        "ceiling": null
      },
      "obstacles": [
        {
          "type": "spike",
          "position": {
            "along": 200,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 230,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 600,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 630,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "wall",
          "position": {
            "along": 900,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 30,
            "height": 50
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 1050,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 1080,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 1110,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        }
      ],
      "decorations": []
    },
    {
      "id": "seg-04-sine-terrain",
      "mode": "real",
      "length": 1500,
      "speed": 1.0,
      "terrain": {
        "type": "function",
        "floor": {
          "function": "sin",
          "amplitude": 30,
          "frequency": 0.008,
          "offset": 80,
          "phase": 0
        },
        "ceiling": null
      },
      "obstacles": [
        {
          "type": "spike",
          "position": {
            "along": 300,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 600,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 630,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "wall",
          "position": {
            "along": 900,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 25,
            "height": 45
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 1100,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 1300,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 1330,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 1360,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        }
      ],
      "decorations": []
    },
    {
      "id": "seg-05-star-gauntlet",
      "mode": "real",
      "length": 1500,
      "speed": 1.0,
      "terrain": {
        "type": "function",
        "floor": {
          "function": "sin",
          "amplitude": 20,
          "frequency": 0.012,
          "offset": 80,
          "phase": 1.57
        },
        "ceiling": null
      },
      "obstacles": [
        {
          "type": "spike",
          "position": {
            "along": 200,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 400,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 430,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 600,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "wall",
          "position": {
            "along": 800,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 30,
            "height": 55
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 950,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 980,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 1010,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 1200,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 1230,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 1260,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        },
        {
          "type": "spike",
          "position": {
            "along": 1290,
            "across": 0,
            "up": 0
          },
          "size": {
            "width": 24,
            "height": 36
          }
        }
      ],
      "decorations": []
    }
  ],
  "triggers": [
    {
      "id": "trg-01-welcome",
      "type": "text",
      "position": 50,
      "duration": 2500,
      "easing": "sine-in-out",
      "params": {
        "text": "Tap to jump",
        "style": "floating"
      }
    },
    {
      "id": "trg-02-sine-intro",
      "type": "text",
      "position": 3000,
      "duration": 2000,
      "easing": "sine-in-out",
      "params": {
        "text": "Ride the wave...",
        "style": "floating"
      }
    },
    {
      "id": "trg-03-speed-up",
      "type": "speed",
      "position": 4500,
      "duration": 500,
      "easing": "ease-in",
      "params": {
        "speed": 1.15
      }
    },
    {
      "id": "sunrise",
      "type": "color",
      "position": 1000,
      "duration": 1000,
      "easing": "sine-in-out",
      "params": {
        "baseColor": "#ffffff",
        "accentColor": "#ffffff",
        "backgroundColor": "#ddddde"
      }
    }
  ],
  "collectibles": [
    {
      "type": "star",
      "position": {
        "along": 3750,
        "across": 0,
        "up": 160
      },
      "index": 0
    },
    {
      "type": "star",
      "position": {
        "along": 4600,
        "across": 0,
        "up": 150
      },
      "index": 1
    },
    {
      "type": "star",
      "position": {
        "along": 5200,
        "across": 0,
        "up": 160
      },
      "index": 2
    }
  ]
}